export default __webpack_public_path__ + "static/media/pic3.e262db5d.jpg";